import { observer } from 'mobx-react-lite';
import React from 'react';
import { withDefaultProps } from 'react-default-props-context';
import { SelfTestT } from 'src/api/types/SelfTestT';
import { useScrollToTop } from 'src/frames/components/useScrollToTop';
import { cn } from 'src/frames/utils/cn';
import { BackButton } from 'src/questions/components/BackButton';
import './DisclaimerView.scss';

export type PropsT = {
  className?: any;
  setShowDisclaimer: Function;
};

type DefaultPropsT = {
  selfTest: SelfTestT;
  portalElm: any;
  goToNextPage: () => void;
};

export const DisclaimerView: React.FC<PropsT> = observer(
  withDefaultProps<PropsT, DefaultPropsT>((props: PropsT & DefaultPropsT) => {
    useScrollToTop('SelfTestView', 'DisclaimerView');

    return (
      <div className={cn('DisclaimerView', 'flex flex-col', props.className)}>
        <div
          id="DisclaimerView__TitleCard"
          className={cn(
            'flex flex-row justify-between',
            'px-4 pt-3 pb-2 tall:py-5'
          )}
        >
          <BackButton
            className="mr-6"
            onClick={() => props.setShowDisclaimer(false)}
          />
          <div className={cn('DisclaimerView__Title')}>
            {props.selfTest.disclaimerTitle}
          </div>
          <BackButton
            className="ml-6 invisible"
            onClick={() => props.setShowDisclaimer(false)}
          />
        </div>
        <div
          className={cn('DisclaimerView__Card', 'flex flex-col', 'px-4 py-2')}
        >
          <div className={cn('DisclaimerView__Body', 'mt-2')}>
            {props.selfTest.disclaimer}
          </div>
          <button
            className={cn('DisclaimerView__Button', 'mt-6')}
            onClick={() => props.goToNextPage()}
          >
            Verstanden
          </button>
        </div>
      </div>
    );
  })
);
